import styled from "styled-components";
export const PageHead = styled.div`
  display: flex;
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 600;
  color:#001E5E;
`;
